import { TsuLoading } from '@/common/components';
import { AppLayout } from '@/layouts/AppLayout';
import { gql, useMutation } from '@apollo/client';
import { useEffect } from 'react';
import { IPunchoutWaivenet, IPunchoutWaivenetVars } from '../../PunchoutInterface';

const WAIVENET_PUNCHOUT_DOCMANA_MUTATION = gql`
  mutation ($destination: String!, $returnURL: String!) {
    punchoutWaivenetDocMana(input: { destination: $destination, returnURL: $returnURL }) {
      success
      link
    }
  }
`;

export function DocManager() {
  const [punchoutWaivenetDocManaMutation, { data, loading }] = useMutation<
    IPunchoutWaivenet,
    IPunchoutWaivenetVars
  >(WAIVENET_PUNCHOUT_DOCMANA_MUTATION, {
    variables: { destination: 'docManager', returnURL: 'https://test.com.au' },
  });

  useEffect(() => {
    punchoutWaivenetDocManaMutation();
  }, []);

  useEffect(() => {
    const handleMessage = (event: MessageEvent<any>) => {
      console.log('[DocumentManager] Got MessageEvent:', event);
      console.log('got here?');
      if (event.origin === 'https://staging.waivenet.com.au') {
        try {
          console.log('[DocumentManager] Event data:', event.data);
        } catch (err) {
          console.error(`[DocumentManager] Error parsing message: ${event.data.toString()}`);
        }
      }
    };
    window.addEventListener('message', handleMessage, false);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <AppLayout title="Document Manager">
      <TsuLoading loading={loading}>
        <iframe
          id="punchout"
          // @ts-ignore
          src={data?.punchoutWaivenetDocMana.link}
          style={{ width: '100%' }}
          height={1080}
        ></iframe>
      </TsuLoading>
    </AppLayout>
  );
}
